/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Stats_ClaimsInputs */

const en_home_stats_claims = /** @type {(inputs: Home_Stats_ClaimsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`24/7 Claims Assistance`)
};

const fr_home_stats_claims = /** @type {(inputs: Home_Stats_ClaimsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assistance aux réclamations 24/7`)
};

/**
* | output |
* | --- |
* | "24/7 Claims Assistance" |
*
* @param {Home_Stats_ClaimsInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_stats_claims = /** @type {((inputs?: Home_Stats_ClaimsInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Stats_ClaimsInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_stats_claims(inputs)
	return fr_home_stats_claims(inputs)
});